import { useMediaQuery } from "@material-ui/core";
import json2mq from "json2mq";
import PreCallTest from "../preCallTest/PreCallTest";
import React, { useEffect, useState } from "react";
import {
	Link,
	Route,
	BrowserRouter as Router,
	Switch,
	Redirect,
} from "react-router-dom";
import DashboardPage from "../dashboard";
import ConfirmationDialog from "../shared/ConfirmationDialog";
import Help from "../help";
import MeetingHistory from "../meetingHistory";
import Upgrade from "../upgrade";
import StatusUpdate from "./components/StatusUpdate";
import { detect } from "detect-browser";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { createBrowserHistory } from "history";
import adapter from "webrtc-adapter";
import SettingPage from "../SettingPage";
import MessagePage from "../MessagePage/message";
import useStore from "./store";
import SpecialistsPage from "../SpecialistsPage";
import { api } from "../shared/utilities/api";
import apiConfigs from "../shared/utilities/apiConfigs";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";

const ROUTES_URL = ["/dashboard", "/SettingPage", "/meeting", "/help", "/MessagePage"];

// Roles that cannot access Setting
const SETTING_DISABLED_ROLES = ["doctor", "clinic"];

// ─── Font injection ────────────────────────────────────────────────────────────
const injectFont = () => {
	if (document.getElementById("drawer-font")) return;
	const link = document.createElement("link");
	link.id = "drawer-font";
	link.rel = "stylesheet";
	link.href = "https://fonts.googleapis.com/css2?family=Manrope:wght@600;700;800&family=Inter:wght@400;500;600&display=swap";
	document.head.appendChild(link);
};

// ─── Inline styles ─────────────────────────────────────────────────────────────
const injectStyles = () => {
	if (document.getElementById("drawer-styles")) return;
	const style = document.createElement("style");
	style.id = "drawer-styles";
	style.textContent = `
		.dm-root, .dm-root *, .dm-root *::before, .dm-root *::after {
			box-sizing: border-box;
		}
		.dm-root {
			display: flex;
			min-height: 100vh;
			font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
		}

		/* ── Sidebar ── */
		.dm-sidebar {
			width: 260px;
			background: #ffffff;
			border-right: 1px solid rgba(0,0,0,0.07);
			display: flex;
			flex-direction: column;
			flex-shrink: 0;
			position: fixed;
			top: 0; left: 0; bottom: 0;
			z-index: 200;
			transition: transform 0.25s ease;
		}
		.dm-sidebar.hidden { transform: translateX(-100%); }

		/* ── Header ── */
		.dm-header {
			background: linear-gradient(135deg, #F4A96A 0%, #E47029 55%, #B94D1A 100%);
			padding: 20px 18px 18px;
			position: relative;
			overflow: hidden;
			flex-shrink: 0;
		}
		.dm-header::after {
			content: '';
			position: absolute;
			width: 140px; height: 140px;
			border-radius: 50%;
			border: 1px solid rgba(255,255,255,0.14);
			right: -40px; bottom: -40px;
		}
		.dm-header::before {
			content: '';
			position: absolute;
			width: 80px; height: 80px;
			border-radius: 50%;
			border: 1px solid rgba(255,255,255,0.1);
			left: -20px; top: -30px;
		}

		.dm-logo-row {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 16px;
			position: relative;
			z-index: 1;
		}
		/* Translucent backing behind the clinic logo — sized to the logo's own
		   aspect ratio (height-driven, width auto) so wide/horizontal logos get
		   a wider card and circular/square logos land in a balanced square
		   container. Mirrors Book App's logo-card. */
		.dm-logo-card {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 104px;
			width: auto;
			min-width: 104px;
			max-width: 210px;
			padding: 8px 16px;
			border-radius: 8px;
			background: radial-gradient(
				ellipse at center,
				rgba(255,255,255,0.32) 0%,
				rgba(255,255,255,0.1) 70%,
				rgba(255,255,255,0) 100%
			);
		}
		.dm-logo {
			height: 100%;
			width: auto;
			max-width: 100%;
			object-fit: contain;
			display: block;
		}
		.dm-logo-fallback {
			font-family: 'Manrope', sans-serif;
			font-weight: 800;
			font-size: 15px;
			color: #fff;
		}

		.dm-user-card {
			display: flex;
			align-items: center;
			gap: 11px;
			position: relative;
			z-index: 1;
			padding: 11px 12px;
			border-radius: 14px;
			background: rgba(255,255,255,0.14);
			border: 1px solid rgba(255,255,255,0.2);
			backdrop-filter: blur(10px);
			transition: background 0.2s ease;
		}
		.dm-avatar {
			width: 42px; height: 42px;
			border-radius: 50%;
			background: rgba(255,255,255,0.22);
			border: 2px solid rgba(255,255,255,0.42);
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: 800;
			font-size: 13px;
			color: #fff;
			flex-shrink: 0;
			font-family: 'Manrope', sans-serif;
			overflow: hidden;
		}
		.dm-avatar img { width: 100%; height: 100%; object-fit: cover; border-radius: 50%; }
		.dm-user-info { min-width: 0; }
		.dm-provider-label {
			font-size: 9.5px;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.08em;
			color: rgba(255,255,255,0.7);
			margin-bottom: 2px;
		}
		.dm-username {
			font-family: 'Manrope', sans-serif;
			font-size: 14px;
			font-weight: 800;
			color: #fff;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 140px;
		}
		.dm-role-pill {
			display: inline-flex;
			align-items: center;
			gap: 5px;
			margin-top: 5px;
			padding: 3px 9px;
			border-radius: 999px;
			background: rgba(255,255,255,0.2);
			font-size: 10.5px;
			font-weight: 700;
			color: #fff;
		}
		.dm-role-dot { width: 5px; height: 5px; border-radius: 50%; background: #fff; }

		/* ── Stats strip ── */
		.dm-stats {
			display: flex;
			gap: 8px;
			padding: 14px 16px;
			border-bottom: 1px solid rgba(0,0,0,0.06);
		}
		.dm-stat {
			flex: 1;
			background: #FAFAFA;
			border: 1px solid rgba(0,0,0,0.06);
			border-radius: 10px;
			padding: 9px 10px;
			text-align: center;
			transition: transform 0.15s ease, border-color 0.15s ease;
		}
		.dm-stat:hover { transform: translateY(-2px); border-color: #F5D5C0; }
		.dm-stat-num {
			font-family: 'Manrope', sans-serif;
			font-size: 17px;
			font-weight: 800;
			color: #E47029;
			line-height: 1;
		}
		.dm-stat-label {
			font-size: 9.5px;
			color: #9A9A9F;
			margin-top: 3px;
			text-transform: uppercase;
			letter-spacing: 0.04em;
		}

		/* ── Nav ── */
		.dm-nav { flex: 1; padding: 12px; overflow-y: auto; }
		.dm-nav-section {
			font-size: 9.5px;
			font-weight: 700;
			color: #C0BDB8;
			text-transform: uppercase;
			letter-spacing: 0.07em;
			padding: 4px 10px;
			margin: 8px 0 6px;
		}
		.dm-nav-section:first-child { margin-top: 0; }

		.dm-nav-item {
			display: flex;
			align-items: center;
			gap: 11px;
			padding: 10px 12px;
			border-radius: 10px;
			font-size: 13.5px;
			color: #6B6760;
			cursor: pointer;
			margin-bottom: 3px;
			text-decoration: none;
			position: relative;
			transition: background 0.18s ease, color 0.18s ease, transform 0.12s ease;
		}
		.dm-nav-item svg { flex-shrink: 0; transition: transform 0.2s ease; }
		.dm-nav-item:hover { background: #F5F3F0; color: #18181A; transform: translateX(2px); }
		.dm-nav-item:hover svg { transform: scale(1.08); }
		.dm-nav-item:active { transform: translateX(2px) scale(0.98); }

		.dm-nav-item.active {
			background: linear-gradient(135deg, #FEF0E7, #FDE6D6);
			color: #E47029;
			font-weight: 700;
			box-shadow: 0 2px 8px -2px rgba(228,112,41,0.3);
		}
		.dm-nav-item.active::before {
			content: '';
			position: absolute;
			left: -12px; top: 50%;
			transform: translateY(-50%);
			width: 3px; height: 18px;
			border-radius: 0 3px 3px 0;
			background: #E47029;
		}

		.dm-nav-item.disabled {
			opacity: 0.4;
			cursor: not-allowed;
			pointer-events: none;
		}

		.dm-badge {
			margin-left: auto;
			min-width: 19px; height: 19px;
			border-radius: 20px;
			background: #E47029;
			color: #fff;
			font-size: 10px;
			font-weight: 700;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			padding: 0 5px;
			animation: dm-badge-pop 0.3s ease;
		}
		@keyframes dm-badge-pop {
			0% { transform: scale(0); }
			70% { transform: scale(1.15); }
			100% { transform: scale(1); }
		}

		/* ── Quick action card ── */
		.dm-quick-card {
			margin: 14px 0 0;
			padding: 14px;
			border-radius: 12px;
			background: linear-gradient(135deg, #FEF0E7, #FDF6F0);
			border: 1px solid #F5D5C0;
			text-align: center;
			cursor: pointer;
			text-decoration: none;
			display: block;
			transition: transform 0.2s ease, box-shadow 0.2s ease;
		}
		.dm-quick-card:hover {
			transform: translateY(-2px);
			box-shadow: 0 8px 20px -8px rgba(228,112,41,0.3);
		}
		.dm-quick-icon {
			width: 34px; height: 34px;
			border-radius: 10px;
			background: #E47029;
			color: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 0 auto 8px;
		}
		.dm-quick-title {
			font-family: 'Manrope', sans-serif;
			font-size: 12.5px;
			font-weight: 700;
			color: #18181A;
			margin-bottom: 2px;
		}
		.dm-quick-sub { font-size: 10.5px; color: #9A9A9F; }

		/* ── Bottom ── */
		.dm-bottom { padding: 14px; border-top: 1px solid rgba(0,0,0,0.06); flex-shrink: 0; }
		.dm-signout {
			width: 100%;
			height: 44px;
			border: none;
			border-radius: 11px;
			background: linear-gradient(135deg, #1976d2 0%, #003fbd 100%);
			color: #fff;
			font-size: 13px;
			font-weight: 700;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 8px;
			font-family: inherit;
			box-shadow: 0 4px 14px rgba(0,63,189,0.25);
			transition: transform 0.15s ease, box-shadow 0.15s ease;
		}
		.dm-signout:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(0,63,189,0.32); }
		.dm-signout:active { transform: translateY(0); }
		.dm-copyright { text-align: center; font-size: 10px; color: #C0BDB8; margin-top: 10px; }

		/* ── Content ── */
		.dm-content {
			flex: 1;
			margin-left: 260px;
			min-height: 100vh;
			transition: margin-left 0.25s ease;
		}
		.dm-content.no-sidebar { margin-left: 0; }

		.dm-overlay {
			display: none;
			position: fixed;
			inset: 0;
			background: rgba(0,0,0,0.3);
			z-index: 199;
		}
		.dm-overlay.visible { display: block; }

		@media (max-width: 1024px) {
			.dm-content { margin-left: 0; }
		}
	`;
	document.head.appendChild(style);
};

// ─── Icons ─────────────────────────────────────────────────────────────────────
const DashboardIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="17" height="17" aria-hidden="true">
		<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
		<rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
	</svg>
);
const MessageIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="17" height="17" aria-hidden="true">
		<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
		<polyline points="22,6 12,13 2,6"/>
	</svg>
);
const SettingIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="17" height="17" aria-hidden="true">
		<circle cx="12" cy="12" r="3"/>
		<path d="M19.07 4.93A10 10 0 0 0 4.93 19.07M21 12a9 9 0 0 0-9-9"/>
	</svg>
);
const HelpIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="17" height="17" aria-hidden="true">
		<circle cx="12" cy="12" r="10"/>
		<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
		<line x1="12" y1="17" x2="12.01" y2="17"/>
	</svg>
);
const ExitIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="15" height="15" aria-hidden="true">
		<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
		<polyline points="16 17 21 12 16 7"/>
		<line x1="21" y1="12" x2="9" y2="12"/>
	</svg>
);
const HelpQuickIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" width="17" height="17" aria-hidden="true">
		<circle cx="12" cy="12" r="10"/>
		<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
		<line x1="12" y1="17" x2="12.01" y2="17"/>
	</svg>
);

// ─── Helpers ───────────────────────────────────────────────────────────────────
// NOTE: if displayName keeps falling back to a role label, the API user object
// likely doesn't return `contact_name` under that key — verify the actual
// field name in the /auth or /me response (could be `name`, `full_name`, etc).
const getDisplayName = (user) => {
	if (!user) return "";
	if (user.contact_name) return user.contact_name;
	const role = user.roles?.[0];
	const map = { admin: "Admin", healthOrgAdmin: "HAdmin", oa: "MOA", doctor: "Doctor", clinic: "Clinic" };
	return map[role] || "User";
};

const getInitials = (name) => {
	if (!name) return "U";
	return name.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase();
};

const formatRole = (role) => {
	const map = { admin: "Admin", healthOrgAdmin: "Health Org Admin", oa: "MOA", doctor: "Doctor", clinic: "Clinic" };
	return map[role] || "Patient";
};

const getProviderTitle = (role) => {
	if (role === "doctor") return "Provider";
	if (role === "oa") return "Clinic Staff";
	if (role === "admin" || role === "healthOrgAdmin") return "Organization";
	if (role === "clinic") return "Clinic";
	return "Patient";
};

// ─── Main component ────────────────────────────────────────────────────────────
const DrawerMenu = () => {
	const [currentTab, setCurrentTab] = useState(ROUTES_URL[0]);
	const [showPreCallTest, setShowPreCallTest] = useState();
	const [closeApplicationPopUp, showCloseApplicationPopUp] = useState(false);
	const [sidebar, setSidebar] = useState(true);
	const [browserAbleToRun, setBrowserAbleToRun] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [unreadCount, setUnreadCount] = useState(0);

	const smallScreenView = useMediaQuery(json2mq({ maxWidth: 1024 }));
	const { setLogin, setOrg, setUser, user, org, login } = useStore();
	const history = createBrowserHistory({ forceRefresh: true });
	const browser = detect();

	const role = user.roles && user.roles[0];
	const isPatient = !user.roles;
	const logo = org.logo || org.logo_link;

	const rawDisplayName = getDisplayName(user);
	const displayName =
		role === "doctor" && rawDisplayName && !rawDisplayName.toLowerCase().startsWith("dr")
			? `Dr. ${rawDisplayName}`
			: rawDisplayName;

	const initials = getInitials(rawDisplayName);
	const providerTitle = getProviderTitle(role);
	const roleLabel = formatRole(role);
	const settingDisabled = SETTING_DISABLED_ROLES.includes(role);

	const fetchUnreadCount = async () => {
		if (!user?._id || !user?.orgs?.[0]) return;
		try {
			const result = await api(
				apiConfigs.baseOption("get", `providerMessages/${user.orgs[0]}_${user._id}`)
			);
			const unread = result?.data?.messages?.filter((m) => !m.read).length || 0;
			setUnreadCount(unread);
		} catch {
			setUnreadCount(0);
		}
	};

	useEffect(() => {
		injectFont();
		injectStyles();
	}, []);

	useEffect(() => {
		if (user) fetchUnreadCount();
	}, [user]);

	useEffect(() => {
		if (smallScreenView) setSidebar(false);
		else setSidebar(true);
	}, [smallScreenView]);

	useEffect(() => {
		if (ROUTES_URL.includes(history.location.pathname)) {
			setCurrentTab(history.location.pathname);
		}
	}, [history.location]);

	useEffect(() => {
		if (!adapter.browserDetails.version) {
			setBrowserAbleToRun(false);
			return;
		}
		if (
			adapter.browserDetails.name !== "safari" &&
			browser.os !== "iOS" &&
			browser.os !== "Mac OS"
		) {
			navigator.permissions.query({ name: "camera" }).then((p) => {
				if (p.state !== "granted") {
					navigator.mediaDevices.getUserMedia({ video: true })
						.then((s) => s.getTracks().forEach((t) => t.stop()))
						.catch(console.warn);
				}
			}).catch((e) => console.log("camera permission error", e));
			navigator.permissions.query({ name: "microphone" }).then((p) => {
				if (p.state !== "granted") {
					navigator.mediaDevices.getUserMedia({ audio: true })
						.then((s) => s.getTracks().forEach((t) => t.stop()));
				}
			}).catch((e) => console.log("mic permission error", e));
		}
	}, []);

	const handleMenuClick = () => setSidebar((prev) => !prev);

	const handleLogOut = async () => {
		localStorage.removeItem("token");
		try { await firebase.auth().signOut(); } catch (e) { console.log(e); }
		setLogin(false);
		setOrg({});
		setUser({});
		window.location.href = "/";
	};

	const handleCloseApplication = async () => {
		setIsLoading(true);
		window.location.replace(org.website);
		showCloseApplicationPopUp(false);
	};

	if (!browserAbleToRun) {
		return (
			<StatusUpdate
				header="Browser Not Supporting"
				message="Please update your browser or use another browser to use this app"
				closeAction={() => {}}
			/>
		);
	}

	return (
		<div className="dm-root">
			<Router history={history}>

				{smallScreenView && sidebar && (
					<div className="dm-overlay visible" onClick={handleMenuClick} />
				)}

				{sidebar && (
					<aside className={`dm-sidebar${!sidebar ? " hidden" : ""}`}>

						{/* Orange header band */}
						<div className="dm-header">
							<div className="dm-logo-row">
								{logo
									? <div className="dm-logo-card"><img className="dm-logo" src={logo} alt="Clinic logo" /></div>
									: <span className="dm-logo-fallback">Porton Health</span>
								}
							</div>
							{login && (
								<div className="dm-user-card">
									<div className="dm-avatar">
										{user.profileImage || user.avatar
											? <img src={user.profileImage || user.avatar} alt={displayName} />
											: initials
										}
									</div>
									<div className="dm-user-info">
										<div className="dm-provider-label">{providerTitle}</div>
										<div className="dm-username">{displayName}</div>
										<div className="dm-role-pill">
											<span className="dm-role-dot" />
											{roleLabel}
										</div>
									</div>
								</div>
							)}
						</div>

						{/* Stats strip — unread only */}
						{login && (
							<div className="dm-stats">
								<div className="dm-stat">
									<div className="dm-stat-num">{unreadCount}</div>
									<div className="dm-stat-label">Unread</div>
								</div>
							</div>
						)}

						{/* Nav items — appointment removed */}
						<nav className="dm-nav">
							<div className="dm-nav-section">Main</div>

							<Link
								to="/dashboard"
								className={`dm-nav-item${currentTab === "/dashboard" ? " active" : ""}`}
								onClick={() => setCurrentTab("/dashboard")}
							>
								<DashboardIcon /> Dashboard
							</Link>

							<Link
								to="/MessagePage"
								className={`dm-nav-item${currentTab === "/MessagePage" ? " active" : ""}`}
								onClick={() => setCurrentTab("/MessagePage")}
							>
								<MessageIcon /> Messages
								{unreadCount > 0 && (
									<span className="dm-badge">{unreadCount > 9 ? "9+" : unreadCount}</span>
								)}
							</Link>

							<div className="dm-nav-section">System</div>

							<Link
								to={settingDisabled ? "#" : "/SettingPage"}
								className={`dm-nav-item${currentTab === "/SettingPage" ? " active" : ""}${settingDisabled ? " disabled" : ""}`}
								onClick={() => !settingDisabled && setCurrentTab("/SettingPage")}
							>
								<SettingIcon /> Setting
							</Link>

							<Link
								to="/help"
								className={`dm-nav-item${currentTab === "/help" ? " active" : ""}`}
								onClick={() => setCurrentTab("/help")}
							>
								<HelpIcon /> Help
							</Link>

							{/* Quick action card */}
							<Link to="/help" className="dm-quick-card">
								<div className="dm-quick-icon"><HelpQuickIcon /></div>
								<div className="dm-quick-title">Need help?</div>
								<div className="dm-quick-sub">Contact Porton support</div>
							</Link>
						</nav>

						<div className="dm-bottom">
							{login && (
								<button className="dm-signout" onClick={handleLogOut}>
									<ExitIcon /> Sign Out
								</button>
							)}
							{isPatient && (
								<button className="dm-signout" onClick={() => showCloseApplicationPopUp(true)}>
									<ExitIcon /> Exit
								</button>
							)}
							<div className="dm-copyright">© {new Date().getFullYear()} Porton Health</div>
						</div>
					</aside>
				)}

				{/* ── Main content — appointment route removed ── */}
				<div className={`dm-content${!sidebar ? " no-sidebar" : ""}`}>
					<Switch>
						<Route path="/dashboard" render={(props) => (
							<DashboardPage {...props} smallScreenView={smallScreenView} handleMenuClick={handleMenuClick} />
						)} />
						<Route path="/meeting" render={(props) => (
							<MeetingHistory {...props} smallScreenView={smallScreenView} handleMenuClick={handleMenuClick} />
						)} />
						<Route path="/SettingPage" render={(props) =>
							settingDisabled ? <Redirect to="/dashboard" /> : (
								<SettingPage {...props} smallScreenView={smallScreenView} handleMenuClick={handleMenuClick} />
							)
						} />
						<Route path="/help" render={(props) => (
							<Help {...props} smallScreenView={smallScreenView} handleMenuClick={handleMenuClick} />
						)} />
						<Route path="/MessagePage" render={(props) => (
							<MessagePage {...props} smallScreenView={smallScreenView} handleMenuClick={handleMenuClick} />
						)} />
						<Route path="/specialists" render={(props) => (
							<SpecialistsPage {...props} smallScreenView={smallScreenView} handleMenuClick={handleMenuClick} />
						)} />
						<Route path="/upgrade" render={(props) => (
							<Upgrade {...props} smallScreenView={smallScreenView} handleMenuClick={handleMenuClick} />
						)} />
						<Route path="/" render={(props) => (
							<DashboardPage {...props} smallScreenView={smallScreenView} handleMenuClick={handleMenuClick} />
						)} />
					</Switch>
				</div>

			</Router>

			{showPreCallTest && (
				<PreCallTest showPreCallTest={showPreCallTest} setShowPreCallTest={setShowPreCallTest} />
			)}

			{closeApplicationPopUp && (
				<ConfirmationDialog
					open={closeApplicationPopUp}
					icon={ContactSupportIcon}
					isLoading={isLoading}
					text="Are you sure you want to leave the application?"
					textStyle={{ fontWeight: "bold", color: "#444444" }}
					onClose={() => showCloseApplicationPopUp(false)}
					onConfirm={handleCloseApplication}
				/>
			)}
		</div>
	);
};

export default DrawerMenu;